/**
* @Author: Michael Neumair <mBook>
* @Date:   2016-08-15T17:05:24+02:00
* @Email:  7q7w7e7r@gmail.com
* @Last modified by:   mBook
* @Last modified time: 2016-10-07T11:43:57+02:00
*/


import React, {Component} from 'react';
import PropTypes from 'prop-types';
import uniqueId from 'lodash/uniqueId';
import inputProps from './../../../utilities/inputProps';

/**
 * AInputCheckbox - a input checkbox which
**/
class AInputCheckbox extends Component {
  render() {
    const {
      id,
      style,
      name,
      checked,
      children,
      error, // eslint-disable-line no-unused-vars
      disabled,
      visualState,
      onChange,
      onFocus,
      onBlur,
      onKeyPress,
      onPress,
    } = this.props;

    const checkedClass = (checked) ? 'checked' : '';

    return (
      <div
        style={style}
        className={`a-input a-input-checkbox ${visualState} ${checkedClass}`}
        onClick={onPress}
      >
        <input
          name={name}
          checked={checked}
          className="a-input-checkbox__input"
          type="checkbox"
          id={id}
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyPress={onKeyPress}
          disabled={disabled}
        />
        <label
          className="a-input-checkbox__label"
          htmlFor={id}
        >
          <p className="a-input-checkbox__text">
            {children}
          </p>
        </label>
      </div>
    );
  }
}
AInputCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  /**
     * the current value/checked of the input - i it is checked
     */
  checked: PropTypes.bool,
  /**
     * this will be the label
     * @type {[type]}
     */
  children: PropTypes.any,
  style: PropTypes.object,
  visualState: PropTypes.string, // passed by inputProps
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onKeyPress: PropTypes.func,
  /**
     * fires when the input has been pressed,
     * it won't fire if the input is disabled
     * @type {Function}
     */
  onPress: PropTypes.func,
};
AInputCheckbox.defaultProps = {
  id: String(uniqueId()),
  children: 'AInputCheckbox',
};
export default inputProps(AInputCheckbox);

